/**
 * 下单成功之后，走web支付
 */
import Order from './order/h5';
import OptionList from './orderview/option-list';

export default Order(OptionList);



// WEBPACK FOOTER //
// ./js/component/recharge/index.js